"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLogin = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Button_1 = require("../../Button");
const Field_1 = require("../Field");
require("./index.scss");
const className = 'login-form';
class FormLogin extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            login: '',
            password: '',
        };
        this.handleLoginChange = (event) => {
            this.setState({ login: event.target.value });
        };
        this.handlePasswordChange = (event) => {
            this.setState({ password: event.target.value });
        };
        this.handleSubmitButton = (event) => {
            event.preventDefault();
            const { login, password } = this.state;
            this.props.onSubmit({
                login,
                password,
            });
        };
    }
    render() {
        const { modificators, isSubmitButtonDisable } = this.props;
        const { login, password } = this.state;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("form", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("h3", { className: `${className}__title` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Login:Title', defaultMessage: 'Login Form' })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Login:LoginLabel', defaultMessage: 'Login' }), onChange: this.handleLoginChange, placeholder: 'Username', value: login })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Login:PasswordLabel', defaultMessage: 'Password' }), onChange: this.handlePasswordChange, placeholder: 'Passwort', type: 'password', value: password })),
                react_1.default.createElement("div", { className: `${className}__buttons` },
                    react_1.default.createElement("div", { className: `${className}__forgot` },
                        react_1.default.createElement("a", { href: '/' },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Login:ForgotPassword', defaultMessage: 'Forgot password?' }))),
                    react_1.default.createElement(Button_1.Button, { text: 'Senden', onClick: this.handleSubmitButton, type: 'submit', disabled: isSubmitButtonDisable })))));
    }
}
exports.FormLogin = FormLogin;
FormLogin.defaultProps = {
    children: null,
    errorMessages: [],
    isSubmitButtonDisable: false,
    onSubmit: () => {
    },
    text: null,
    title: null,
};
//# sourceMappingURL=index.js.map